import { ProviderLogo } from '@amzn/fire-tv-campaign-automation-service';

const PROVIDER_LOGO_DISPLAY_NAMES: Partial<Record<ProviderLogo, string>> = {
  [ProviderLogo.ALEXA]: 'Alexa',
  [ProviderLogo.ALEXA_PLUS]: 'Alexa+',
  [ProviderLogo.AMAZONAPPSTORE_LOGO]: 'Amazon Appstore',
  [ProviderLogo.AMAZONAPPSTORE_LOGO_STACKED]: 'Amazon Appstore (Stacked)',
  [ProviderLogo.AMC_PLUS]: 'AMC+',
  [ProviderLogo.AUDIBLE]: 'Audible',
  [ProviderLogo.BET]: 'BET',
  [ProviderLogo.COMIXOLOGY]: 'Comixology',
  [ProviderLogo.COMIXOLOGY_UNLIMITED]: 'Comixology Unlimited',
  [ProviderLogo.FIRE_CHANNELS]: 'Fire Channels',
  [ProviderLogo.FIRE_TV]: 'Fire TV',
  [ProviderLogo.FIRE_TV_ORANGE_TABLETS]: 'Fire TV (Orange)',
  [ProviderLogo.GOODREADS]: 'Goodreads',
  [ProviderLogo.KIDS_PLUS]: 'Kids Plus',
  [ProviderLogo.KIDS_PLUS_STACKED]: 'Kids Plus (Stacked)',
  [ProviderLogo.KINDLE]: 'Kindle',
  [ProviderLogo.KINDLE_UNLIMITED]: 'Kindle Unlimited',
  [ProviderLogo.LUNA]: 'Luna',
  [ProviderLogo.PRIME_LOGO_BLUE]: 'Prime (Blue)',
  [ProviderLogo.PRIME_LOGO_WHITE]: 'Prime (White)',
  [ProviderLogo.PRIME_VIDEO]: 'Prime Video',
  [ProviderLogo.PRIME_VIDEO_BLUE]: 'Prime Video (Blue)',
  [ProviderLogo.PRIME_VIDEO_WHITE]: 'Prime Video (White)',
  [ProviderLogo.PRIME_VIDEO_WHITE_ON_BLUE]: 'Prime Video (White on Blue)',
  [ProviderLogo.TUBI]: 'Tubi',
};

export function getProviderLogoOptions() {
  return Object.entries(PROVIDER_LOGO_DISPLAY_NAMES).map(([value, name]) => ({
    value,
    name: name!,
  }));
}
